<template>
  <div >
    <m1-demo-box v-if="uiVersion === 1"
                :demoOption="demoOption" :hasSaveQuickPick="hasSaveQuickPick" :hasTotalRecords="hasTotalRecords">

      <template slot="top">
        <slot name="top">
        </slot>
      </template>
      <slot />

    </m1-demo-box>

    <m2-demo-box  v-if="uiVersion === 2"
                  :demoOption="demoOption">
      <slot></slot>
    </m2-demo-box>


  </div>
</template>

<script>
  import M1DemoBox from '@/components/demo/M1DemoBox'
  import M2DemoBox from '@/components/demo/M2DemoBox'

  export default {
    components: {
      M1DemoBox,
      M2DemoBox
    },
    props: {
      demoOption: {
        type: String,
        default: 'demo'  // 'normal', 'quickPick', 'suppression', 'search', 'demo', 'interests', 'audience'
      },
      hasSaveQuickPick: {
        type: Boolean,
        default: true
      },
      hasTotalRecords: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      uiVersion () {
        return this.$store.state.config.uiVersion
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/demo/MDemoBox.vue